import { UserType } from "../configs/constants";

import Forgot from "../pages/Auth/Forgot/Forgot";
import Login from "../pages/Auth/Login/Login";
import Register from "../pages/Auth/Register/Register";
import CustomerExternalDisplay from "../pages/Content/ExternalDisplays/Customer/CustomerExternalDisplay";
import KitchenExternalDisplay from "../pages/Content/ExternalDisplays/Kitchen/KitchenExternalDisplay";

import QRcart from "../pages/Content/QRorders/QRcart";
import QRorderHistory from "../pages/Content/QRorders/QRorderHistory";
import QRordering from "../pages/Content/QRorders/QRordering";

import TransactionsInvoice from "../pages/Content/Transactions/TransactionsInvoice";

// ✅ Currency formatter
export const currencyFormatters = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "SAR",
});

export const filterPagesByAddons = (ContentPages, authUser) => {
  // ✅ Logged-in users (POS users)
  if (authUser) {
    let TempContentPages = ContentPages.filter((page) => {
      // If addonName is not defined or null, always include the page
      if (page.addonName === undefined || page.addonName === null) return true;

      // Only include if addon exists in authUser.active_addons
      return (authUser.active_addons || []).some(
        (addon) => addon.name === page.addonName,
      );
    });

    // Permissions filters
    if (!authUser.can_see_transactions) {
      TempContentPages = TempContentPages.filter(
        (page) => page.name !== "transactions",
      );
    }
    if (!authUser.can_view_customer) {
      TempContentPages = TempContentPages.filter(
        (page) => page.name !== "customers",
      );
    }
    if (!authUser.can_view_sales_invoice) {
      TempContentPages = TempContentPages.filter(
        (page) => page.name !== "sales_invoice",
      );
    }
    if (authUser.is_vat_exempt || authUser.vat === null) {
      TempContentPages = TempContentPages.filter(
        (page) => page.name !== "tax_configuration",
      );
    }
    if (
      authUser.features &&
      !authUser.features.some(
        (feature) =>
          feature.title === "External Integration" && feature.status === 1,
      )
    ) {
      TempContentPages = TempContentPages.filter(
        (page) => page.name !== "external-integration",
      );
    }

    // Allowed pages for Admin/Owner users (non-employee)
    const allowedNonEmployeePages = [
      "register-confirmed",
      "home",
      "pos",
      "orders",
      "view_order",
      "edit_order",
      "transactions",
      "products_list",
      "products",
      "categories",
      "units",
      "options",
      "inventory",
      "stock",
      "low-stock",
      "stock-adjustment",
      "view_stock_adjustment",
      "stock-transfer",
      "view_transfer",
      "edit_transfer",
      "branches",
      "tables",
      "customers",
      "view_customer",
      "ticketing",
      "print_ticket",
      "sales_invoice",
      "view_sales_invoice",
      "edit_sales_invoice",
      "employees",
      "discounts",
      "customer_display_screen",
      "kitchen_display_screens",
      "helpdesk",
      "reports",
      "sales-summary",
      "sales-by-items",
      "sales-by-categories",
      "refunds-by-items",
      "refunds-by-categories",
      "report-by-branch",
      "store-configuration",
      "subscriptions",
      "invoices",
      "payments",
      "addons",
      "website",
      "addon_detail",
      "external-integration",
      "tax_configuration",
      "zatca",
      "zatca_onboarding",
      "zatca_device_details",
      "zatca_invoice_issues",
    ];

    // Allowed pages for Employee users
    const allowedEmployeePages = [
      "home",
      "pos",
      "orders",
      "view_order",
      "edit_order",
      "transactions",
      "products_list",
      "products",
      "inventory",
      "stock",
      "low-stock",
      "stock-adjustment",
      "view_stock_adjustment",
      "stock-transfer",
      "view_transfer",
      "edit_transfer",
      "tables",
      "customers",
      "view_customer",
      "ticketing",
      "print_ticket",
      "sales_invoice",
      "view_sales_invoice",
      "edit_sales_invoice",
      "customer_display_screen",
      "kitchen_display_screens",
      "helpdesk",
      "reports",
      "sales-summary",
      "sales-by-items",
      "sales-by-categories",
      "refunds-by-items",
      "refunds-by-categories",
      "zatca",
      "zatca_onboarding",
      "zatca_device_details",
      "zatca_invoice_issues",
    ];

    return TempContentPages.filter((page) => {
      if (authUser.type !== UserType.Employee) {
        return allowedNonEmployeePages.includes(page.name);
      }
      return allowedEmployeePages.includes(page.name);
    });
  }

  // ✅ Not logged in users (public routes)
  return [
    {
      path: "/login",
      name: "login",
      text: "login",
      component: Login,
      icon: false,
      showInSider: false,
    },
    {
      path: "/register",
      name: "register",
      text: "register",
      component: Register,
      icon: false,
      showInSider: false,
    },
    {
      path: "/forgot",
      name: "forgot",
      text: "forgot",
      component: Forgot,
      icon: false,
      showInSider: false,
    },
    {
      path: "/transactions/invoice",
      name: "transactions-invoice",
      text: "transactions_invoice",
      component: TransactionsInvoice,
      icon: false,
      showInSider: false,
    },
    {
      path: "/qr/ordering",
      name: "qr-ordering",
      text: "qr_ordering",
      component: QRordering,
      icon: false,
      showInSider: false,
    },
    {
      path: "/qr/cart",
      name: "qr-cart",
      text: "qr_cart",
      component: QRcart,
      icon: false,
      showInSider: false,
    },
    {
      path: "/qr/history",
      name: "qr-history",
      text: "qr_history",
      component: QRorderHistory,
      icon: false,
      showInSider: false,
    },

    // ✅ Public display pages (NO login)
    {
      path: "/cds",
      name: "customer-external-display",
      text: "customer_external_display",
      component: CustomerExternalDisplay,
      icon: false,
      showInSider: false,
    },
    {
      path: "/kds",
      name: "kitchen-external-display",
      text: "kitchen_external_display",
      component: KitchenExternalDisplay,
      icon: false,
      showInSider: false,
    },

    // Fallback
    {
      path: "*",
      name: "register",
      text: "register",
      component: Register,
      icon: false,
      showInSider: false,
    },
  ];
};
